import { expenseUsesDisbursementCode } from '../review-expense/utils/contract-expense-json';
import { linkedReviewDocument, reviewDocumentNature, canReviewCardDocument } from '../credit-card-transactions/expense-review';
import { resolveDefaultTaxCode } from '../../utils/tax-code-resolvers';

export const linkedReviewInvoice = (statement, transaction) => {
  const document = linkedReviewDocument(statement, transaction);
  return reviewDocumentNature(statement, transaction, document) === 'invoice' ? document : null;
};

export const canReviewCardInvoice = (statement, transaction) =>
  canReviewCardDocument(statement, transaction, linkedReviewInvoice(statement, transaction));

// New draft lines must not inherit the persisted identity of an existing line.
export const createInvoiceLine = (json, taxProfile) => ({
  _view_id: Math.max(-1, ...(json.ListItem || []).map(line => Number(line._view_id) || 0)) + 1,
  Description: '', Total: 0, IsBillable: 0,
  GLNatural: json.GLNatural || json.ListSupplier?.[0]?.GLNatural || '',
  TaxCode: json.TaxCode || resolveDefaultTaxCode(taxProfile),
});

const hasValue = value => value !== null && value !== undefined && String(value).trim() !== '';
export const hasValidLineAmounts = json => (json?.ListItem || []).every(line => hasValue(line.Total) && Number.isFinite(Number(line.Total)));

// Preserve negative credit lines. Require actual supplier/coding identifiers,
// not only an OCR name, before marking the invoice reviewed.
export const validateInvoiceReview = json => {
  const errors = [];
  const supplier = json.ListSupplier?.[0];
  if (!supplier?.Name || !(supplier.Index || supplier.Number)) errors.push('supplier');
  if (!json.InvoiceNo?.trim()) errors.push('number');
  if (!json.InvoiceDate || Number.isNaN(Date.parse(json.InvoiceDate))) errors.push('date');
  if (!json.ListItem?.length) errors.push('lines');
  else if (!hasValidLineAmounts(json) || json.ListItem.some(line =>
    !line.Description?.trim() || !line.TaxCode || !(expenseUsesDisbursementCode(json, line) ? line.CostType && line.MatterId : line.GLNatural)
  )) errors.push('line_fields');
  return errors;
};

// Only monetary inputs trigger recalculation; typing a description must not
// invalidate an in-flight tax result. The server owns tax and rounding rules.
export const invoiceTaxInputs = json => JSON.stringify([
  (json?.ListItem || []).map(line => [line._view_id, line.line_id, Number(line.Total), line.TaxCode, line.IsBillable, line.Type]),
  json?.TaxDeduction, json?.TaxCode, json?.ListSupplier?.[0]?.Number,
]);
